import { Controller } from '@hotwired/stimulus'

const escapeCsvField = (value) => `"${String(value ?? '').replace(/"/g, '""')}"`

// Connects to data-controller="tool-csv-download"
// Downloads the generated results (passed in as JSON) as a CSV file.
export default class extends Controller {
  static values = { results: Array, filename: String }

  download() {
    const rows = [
      ['Filename', 'Title', 'Description', 'Keywords'],
      ...this.resultsValue.map((result) => [
        result.filename,
        result.title,
        result.description,
        (result.keywords || []).join(', ')
      ])
    ]
    const csv = rows.map((row) => row.map(escapeCsvField).join(',')).join('\r\n')

    // BOM so Excel opens the file as UTF-8
    const blob = new Blob(['\ufeff', csv], { type: 'text/csv;charset=utf-8' })
    const link = document.createElement('a')
    link.href = URL.createObjectURL(blob)
    link.download = `${this.filenameValue || 'results'}-${this.timestamp()}.csv`
    link.click()
    URL.revokeObjectURL(link.href)
  }

  // e.g. 2026-07-23-141605, so repeat downloads get unique filenames
  timestamp() {
    const pad = (number) => String(number).padStart(2, '0')
    const now = new Date()
    return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}-${pad(now.getHours())}${pad(
      now.getMinutes()
    )}${pad(now.getSeconds())}`
  }
}
